<template>
    <div class="heatstroke-level-3">
        <div class="heatstroke-level-3__character">
            <img :src="bear" alt="character_1" />
        </div>
        <div class="heatstroke-level-3__signs">
            <img :src="signs" alt="" />
        </div>
        <p class="heatstroke-level-3__measurementdate">
            {{ date }} 時点のデータです。
        </p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            assetPath: "/files/items/heatstroke"
        };
    },
    props: {
        date: {
            type: String,
            required: true
        }
    },
    computed: {
        bear() {
            return this.assetPath + "/level3/bear.png";
        },
        signs() {
            return this.assetPath + "/level3/signs.png";
        }
    }
};
</script>
